import { defineMessages } from 'react-intl';
import type { LevelPrefenceEnum } from '@foundershub/api-client';

export const levelPreferenceLabels = defineMessages<LevelPrefenceEnum>({
  one: {
    defaultMessage: 'One',
    description: 'level preference label',
  },
  two: {
    defaultMessage: 'Two',
    description: 'level preference label',
  },
  three: {
    defaultMessage: 'Three',
    description: 'level preference label',
  },
  four: {
    defaultMessage: 'Four',
    description: 'level preference label',
  },
  five: {
    defaultMessage: 'Five',
    description: 'level preference label',
  },
  six: {
    defaultMessage: 'Six',
    description: 'level preference label',
  },
  seven: {
    defaultMessage: 'Seven',
    description: 'level preference label',
  },
});
